__turbopack_context__.v({
  "contactDrawerGlow": "contact-drawer-module-scss-module__wJ1ZtW__contactDrawerGlow",
  "content": "contact-drawer-module-scss-module__wJ1ZtW__content",
  "fieldError": "contact-drawer-module-scss-module__wJ1ZtW__fieldError",
  "fieldRoot": "contact-drawer-module-scss-module__wJ1ZtW__fieldRoot",
  "fieldRootError": "contact-drawer-module-scss-module__wJ1ZtW__fieldRootError",
  "form": "contact-drawer-module-scss-module__wJ1ZtW__form",
  "formColumn": "contact-drawer-module-scss-module__wJ1ZtW__formColumn",
  "formColumnSuccess": "contact-drawer-module-scss-module__wJ1ZtW__formColumnSuccess",
  "handle": "contact-drawer-module-scss-module__wJ1ZtW__handle",
  "honeypot": "contact-drawer-module-scss-module__wJ1ZtW__honeypot",
  "input": "contact-drawer-module-scss-module__wJ1ZtW__input",
  "overlay": "contact-drawer-module-scss-module__wJ1ZtW__overlay",
  "overlayClosing": "contact-drawer-module-scss-module__wJ1ZtW__overlayClosing",
  "overlayOpen": "contact-drawer-module-scss-module__wJ1ZtW__overlayOpen",
  "panel": "contact-drawer-module-scss-module__wJ1ZtW__panel",
  "sideTitle": "contact-drawer-module-scss-module__wJ1ZtW__sideTitle",
  "socialLink": "contact-drawer-module-scss-module__wJ1ZtW__socialLink",
  "socials": "contact-drawer-module-scss-module__wJ1ZtW__socials",
  "socialsTitle": "contact-drawer-module-scss-module__wJ1ZtW__socialsTitle",
  "status": "contact-drawer-module-scss-module__wJ1ZtW__status",
  "statusError": "contact-drawer-module-scss-module__wJ1ZtW__statusError",
  "statusSuccess": "contact-drawer-module-scss-module__wJ1ZtW__statusSuccess",
  "submitBtn": "contact-drawer-module-scss-module__wJ1ZtW__submitBtn",
  "subtitle": "contact-drawer-module-scss-module__wJ1ZtW__subtitle",
  "successBanner": "contact-drawer-module-scss-module__wJ1ZtW__successBanner",
  "successIcon": "contact-drawer-module-scss-module__wJ1ZtW__successIcon",
  "textarea": "contact-drawer-module-scss-module__wJ1ZtW__textarea",
  "title": "contact-drawer-module-scss-module__wJ1ZtW__title",
  "wrapper": "contact-drawer-module-scss-module__wJ1ZtW__wrapper",
  "wrapperClosing": "contact-drawer-module-scss-module__wJ1ZtW__wrapperClosing",
  "wrapperOpen": "contact-drawer-module-scss-module__wJ1ZtW__wrapperOpen",
});
